/*
 * (c) Copyright, 2026, Medidata Solutions Worldwide, Inc. All rights reserved.
 *
 * Utility functions for PropertySearchDataGrid
 */

import type { ActionMenuItem } from '../../hooks/useFsiActionMenu'

export interface DropdownItem {
  eventKey: string
  title: string
  disabled?: boolean
  hasDividerAfter?: boolean
  onClick?: () => void
  subItems?: Array<{ eventKey: string; title: string; disabled?: boolean; onClick?: () => void }>
}

/**
 * Transform ActionMenuItem[] from useFsiActionMenu to onex-design Dropdown items format
 * Enables submenu support via subItems prop
 */
export const transformToDropdownItems = (menuItems: ActionMenuItem[], t: (key: string) => string): DropdownItem[] => {
  const result = menuItems
    .filter((item) => !item.divider)
    .map((item, index) => {
      const originalIndex = menuItems.indexOf(item)
      const nextOriginalItem = menuItems[originalIndex + 1]
      const hasDividerAfter = nextOriginalItem?.divider === true

      const dropdownItem: any = {
        eventKey: item.value || `item-${index}`,
        title: item.value ? t(item.value) : '',
        disabled: item.disabled,
        hasDividerAfter
      }

      if (item.submenu && item.submenu.length > 0) {
        dropdownItem.subItems = item.submenu.map((subItem, subIndex) => ({
          eventKey: subItem.value || `subitem-${subIndex}`,
          title: subItem.value ? t(subItem.value) : '',
          disabled: subItem.disabled,
          onClick: subItem.action
        }))
      } else {
        dropdownItem.onClick = item.action
      }

      return dropdownItem
    })

  return result
}
